import { genHtmlOptions, genMenuItems } from "../utils";

export const STATUSES: Record<string, string> = {};

export const STATUS_CREATED = 1;
export const STATUS_REJECTED = 2;
export const STATUS_PROCESSING = 3;
export const STATUS_SUCCESS = 4;
export const STATUS_PARTIAL_SUCCESS = 5;
export const STATUS_FAILURE = 6;

STATUSES[STATUS_CREATED] = 'Created';
STATUSES[STATUS_REJECTED] = 'Rejected';
STATUSES[STATUS_PROCESSING] = 'Processing';
STATUSES[STATUS_SUCCESS] = 'Completed';
STATUSES[STATUS_PARTIAL_SUCCESS] = 'Completed with errors';
STATUSES[STATUS_FAILURE] = 'Failure';

export const statusMenuItems = genMenuItems(STATUSES);
export const statusOptions = genHtmlOptions(STATUSES);


export const getImportStateDisplay = (v: number): string => {
    // const statusMap: Record<string, string> = {
    //   "1": "Queued",
    //   "2": "Rejected",
    //   "3": "Processing",
    //   "4": "Completed",
    //   "5": "Completed with errors",
    //   "6": "Failure"
    // }
    return STATUSES.hasOwnProperty(v.toString()) ? STATUSES[v] : "Unknown";
  }

export const ORIGIN_UNKNOWN: number = 0
export const ORIGIN_API: number = 1
export const ORIGIN_INTEGRATION: number = 2
export const ORIGIN_DASHBOARD: number = 3
export const ORIGIN_CLI: number = 4
export const ORIGIN_URL: number = 5
export const ORIGIN_RECTIFICATION: number = 6;
export const ORIGIN_PREPROCESSING: number = 7;
export const ORIGINS: Record<number, string> = {};
ORIGINS[ORIGIN_UNKNOWN] = "Unknown";
ORIGINS[ORIGIN_API] = "Import API";
ORIGINS[ORIGIN_INTEGRATION] = "Integration";
ORIGINS[ORIGIN_DASHBOARD] = "Dashboard";
ORIGINS[ORIGIN_CLI] = "CLI";
ORIGINS[ORIGIN_URL] = "URL";
ORIGINS[ORIGIN_RECTIFICATION] = "Booking rectification";
ORIGINS[ORIGIN_PREPROCESSING] = "Parallel import";

export const originMenuItems = genMenuItems(ORIGINS);
export const originOptions = genHtmlOptions(ORIGINS);

export const getOriginDisplay = (v: number): string => {
  // console.log('getOriginDisplay', v, ORIGINS);
  return ORIGINS.hasOwnProperty(v) ? ORIGINS[v] : ORIGINS[ORIGIN_UNKNOWN];
}

export const getImportState = (importRow: any) => {
    if (!importRow || !importRow.sources || importRow.sources.length === 0) {
      if (importRow.processing_finished_ts) {
        return "Failed (no sources)";
      } else if (importRow.processing_started_ts) {
        return "Failed";
      } else {
        return"Queued";
      }
    }
    else if (importRow?.sources.length === 1) {
      return getImportStateDisplay(importRow.sources[0].state)
    } else {
      return `${importRow.sources.length} sources (${importRow.sources.map((x: any) => getImportStateDisplay(x.state))})`
    }
};

